import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';

export function AdminSessionPrintPage() {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  const sessionQuery = useQuery({
    queryKey: ['admin-session'],
    queryFn: api.adminSession,
  });

  const workshopsQuery = useQuery({
    queryKey: ['admin-workshops'],
    queryFn: api.adminWorkshops,
    enabled: sessionQuery.isSuccess,
  });

  useEffect(() => {
    if (sessionQuery.error instanceof ApiError && sessionQuery.error.status === 401) {
      navigate('/admin/login');
    }
  }, [navigate, sessionQuery.error]);

  const workshop = workshopsQuery.data?.workshops.find((item) => item.id === Number(sessionId));

  if (!workshop) {
    return <p className="print-loading">Teilnehmerliste wird geladen…</p>;
  }

  return (
    <div className="print-page">
      <div className="print-toolbar">
        <button className="button" type="button" onClick={() => window.print()}>
          Drucken / PDF
        </button>
      </div>

      <article className="print-sheet">
        <header className="print-sheet__header">
          <p>!GROW 2026</p>
          <h1>Teilnehmerliste</h1>
          <strong>{workshop.title}</strong>
          <span>
            {workshop.startTime} – {workshop.endTime} · <span className="room-label">{workshop.roomName}</span>
          </span>
          <span>
            {workshop.bookedCount} angemeldet · {workshop.isBookable ? `${workshop.remainingSeats ?? 0} frei` : 'nicht buchbar'}
          </span>
        </header>

        {workshop.subtitle ? <p className="print-sheet__intro">{workshop.subtitle}</p> : null}

        <table className="print-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Zugangscode</th>
            </tr>
          </thead>
          <tbody>
            {workshop.participants.map((participant) => (
              <tr key={participant.id}>
                <td>{participant.displayName}</td>
                <td>{participant.code}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </article>
    </div>
  );
}
